import { DistributionTiming } from '../../enums/distribution-timing';

export class DistributionStreet {
    public id: string;
    public streetId: string;
    public percentageComplete: number;
    public percentageCompleteEarly: number;
    public percentageCompleteLate: number;
    public distributionTiming: DistributionTiming;

    constructor();
    constructor(json: any)
    constructor(json?: DistributionStreet) {
        if (json) {
            this.id = json.id;
            this.streetId = json.streetId;
            this.percentageComplete = json.percentageComplete;
            this.percentageCompleteEarly = json.percentageCompleteEarly;
            this.percentageCompleteLate = json.percentageCompleteLate;
            this.distributionTiming = this.calculateTiming();
        }
    }

    calculateTiming(): DistributionTiming {
        if (this.percentageCompleteEarly && this.percentageCompleteEarly !== 0 && this.percentageCompleteLate && this.percentageCompleteLate !== 0) {
            return DistributionTiming.Both;
        } else if (this.percentageCompleteEarly && this.percentageCompleteEarly !== 0) {
            return DistributionTiming.Early;
        } else if (this.percentageCompleteLate && this.percentageCompleteLate !== 0) {
            return DistributionTiming.Late;
        } else {
            return DistributionTiming.OnTime;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/distribution/street.ts